import React from 'react';

const HintMessage = ({ imgUrl, msg }) => {
  return (
    <div className='bg-[#EAEDFF] rounded-[28px] text-[#5666C0] flex items-center py-1 gap-2 my-2'>
      <img src={imgUrl} className='w-[16px] h-[16px] ml-4' alt='' />
      <div className='text-xs leading-[18px] text-[#5666C0] font-medium'>
        {msg}
      </div>
    </div>
  );
};

export default HintMessage;
